import CategoryForm from "./CategoryForm";
import "./styles.scss";

export default { CategoryForm };
